import { render, staticRenderFns } from "./FilterInjuriesDialog.vue?vue&type=template&id=2ab29c50&scoped=true"
import script from "./FilterInjuriesDialog.vue?vue&type=script&lang=js"
export * from "./FilterInjuriesDialog.vue?vue&type=script&lang=js"
import style0 from "./FilterInjuriesDialog.vue?vue&type=style&index=0&id=2ab29c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab29c50",
  null
  
)

export default component.exports